// extracted by mini-css-extract-plugin
module.exports = {"LoadingSpinnerWrapper":"LoadingSpinner_LoadingSpinnerWrapper__1qLa6","FullScreenWrapper":"LoadingSpinner_FullScreenWrapper__3IGoI"};